import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Button } from '@mui/material';
import React, { useState } from 'react';

import { AttachOfferDialog } from '@/components/emailWindow/components/attachments/components/attachOffer/AttachOfferDialog.comp.tsx';
import { useResolveProcessResource } from '@/components/emailWindow/components/attachments/components/attachOffer/util/useResolveProcessResource.util.ts';
import { AnnouncementAnchor } from '@/contexts/announcements/AnnouncementAnchor.comp.tsx';
import { AnnouncementAnchorKey } from '@/contexts/announcements/announcements.definitions.ts';
import { useCanReadProcessData } from '@/utils/usePermissions.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  emailId: string;
}

export const AttachOfferButton: React.FC<Props> = ({ emailId }) => {
  const { t } = useTranslationWithPrefix('views.emails.newEmail.attachOffer');
  const { processResource } = useResolveProcessResource();
  const [isOpen, setIsOpen] = useState(false);
  const canReadProcessData = useCanReadProcessData();

  if (!processResource || !canReadProcessData) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <AnnouncementAnchor
        anchorKey={AnnouncementAnchorKey.EMAIL_ATTACH_OFFER}
        sx={{ display: 'inline-flex' }}
      >
        <Button
          onClick={() => setIsOpen(true)}
          size="small"
          startIcon={<DescriptionOutlinedIcon />}
          variant="outlined"
        >
          {t('button')}
        </Button>
      </AnnouncementAnchor>
      {isOpen && (
        <AttachOfferDialog
          emailId={emailId}
          onClose={() => setIsOpen(false)}
          processId={processResource.resourceId}
        />
      )}
    </Box>
  );
};
